import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Pagination, Row, Spin } from "antd";
import moment from "moment";

import Swal from "sweetalert2";

import partnersApi from "../../../apis/Partners.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import CommunityImage from "../../channel/community/CommunityImage";

const EditCommunityListComponent = ({
	mediaResult,
	// selectCommunity,
	setSelectCommunity,
	setCommunityWriteShow,
}) => {
	const user = useSelector((state) => state.auth.user);
	const history = useHistory();
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const obsRef = useRef(null); //observer Element
	const preventRef = useRef(true); //옵저버 중복 실행 방지
	// const endRef = useRef(false); //모든 글 로드 확인
	// const [page, setPage] = useState(3); //현재 페이지

	const [pageSize, setPageSize] = useState(5);
	const [currentPageNumber, setCurrentPageNumber] = useState(1);

	const [communityList, setCommunityList] = useState([]);
	const [totalCount, setTotalCount] = useState(0);

	/**
	 * page 넘김
	 */
	const handleChangePagination = async (pageNumber) => {
		// const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
	};

	const listRef = useRef();

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});

		// const observer = new IntersectionObserver(obsHandler, {threshold: 0.5});
		// if (obsRef.current) observer.observe(obsRef.current);
		// return () => {
		//     observer.disconnect();
		// }
	}, []);

	useEffect(() => {
		getCommunity();
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, [currentPageNumber]);

	// const obsHandler = ((entries) => { //옵저버 콜백함수
	//     const target = entries[0];
	//     if (!endRef.current && target.isIntersecting && preventRef.current) { //옵저버 중복 실행 방지
	//         preventRef.current = false; //옵저버 중복 실행 방지
	//         setPage(prev => prev + 3); //페이지 값 증가
	//     }
	// })

	// useEffect(() => {
	//     if (user?.id) {
	//         if (totalCount === 0) {
	//             getCommunity()
	//         } else {
	//             if (totalCount >= pageSize) {
	//                 getCommunity()
	//             }
	//         }
	//     }
	// }, [user, pageSize])

	// const getCommunity = useCallback(async () => {
	//     setIsLoading(true);
	//     let param = {
	//         influencerId: (user?.role === "level_1" || user?.role === "super_admin") ? user?.id : user?.partners_id,
	//         offset: 0,
	//         pageSize: pageSize
	//     }
	//     const res = await partnersApi.readCommunityList(param);
	//     if (res.code === 200) {
	//         setTotalCount(res.result.totalCnt);
	//         setCommunityList(res.result?.communityDTOList);
	//         preventRef.current = true;
	//     }
	//     setIsLoading(false);
	// }, [pageSize])

	const getCommunity = async () => {
		setIsLoading(true);
		let param = {
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			offset: (currentPageNumber - 1) * pageSize,
			pageSize: pageSize,
			pageType: "admin",
		};
		const res = await partnersApi.readCommunityList(param);
		if (res.code === 200) {
			setTotalCount(res.result.totalCnt);
			setCommunityList(res.result?.communityDTOList);
			preventRef.current = true;
		}
		setIsLoading(false);
	};

	const handleCommunity = (item) => {
		if (!item?.is_reservation) {
			let url = `/together/channel/community/${item.id}?id=${
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.influencer_id
					: user?.role
			}&whereShow=edit`;
			if (user?.role === "super_admin" || user?.role === "level_1") {
				url = `https://www.dangyoung.com/together/@${item?.influencer_name}/community/${item.id}`;
			}
			if (mediaResult) {
				history.push(url);
			} else {
				window.open(url);
			}
		} else {
			setSelectCommunity(item);
			setCommunityWriteShow(true);
		}
	};

	/**
	 * 소통글 수정
	 * @param e
	 * @returns {Promise<void>}
	 */
	const editCommunity = async (e, item) => {
		e.stopPropagation();
		setSelectCommunity(item);
		setCommunityWriteShow(true);
	};

	/**
	 * 소통글 삭제
	 * @param e
	 * @returns {Promise<void>}
	 */
	const deleteCommunity = async (e, item) => {
		e.stopPropagation();
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 게시글을 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setIsLoading(true);
				const param = {
					communityId: item.id,
					// userId: (user?.role === "level_1" || user?.role === "super_admin") ? user?.id : user?.partners_id,
					userId: user?.id,
				};
				const res = await partnersApi.deleteCommunityContent(param);
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "성공적으로 삭제되었습니다!",
						confirmButtonText: "확인",
					}).then(() => {
						getCommunity();
						setIsLoading(false);
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						setIsLoading(true);
					});
				}
				setIsLoading(false);
			}
		});
	};

	return (
		<>
			{!!isLoading && (
				<Spin
					style={{
						margin: "auto",
						width: "100%",
						paddingTop: "2em",
						position: "absolute",
						left: 0,
						right: 0,
						zIndex: 9,
					}}
				/>
			)}
			{communityList?.length ? (
				<>
					{communityList?.map((item, idx) => (
						<div style={{ position: "relative", width: "100%" }}>
							{!!isLoading && (
								<div
									style={{
										position: "absolute",
										left: 0,
										right: 0,
										top: 0,
										bottom: 0,
										zIndex: 9,
										display: "flex",
										backgroundColor: "rgba(0,0,0,0.1)",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<Spin
										size={"large"}
										style={{
											width: "100%",
											paddingBottom: "4em",
										}}
									/>
								</div>
							)}
							<div
								key={`community-${idx}`}
								className={`home-community-each modal-community community-each-page community-list-content`}
								onClick={() => handleCommunity(item)}
								ref={listRef}
							>
								{!!item?.is_reservation && (
									<Button
										style={{
											position: "absolute",
											right: mediaResult ? "0.5em" : "2em",
											top: mediaResult ? "1em" : "2em",
											display: "flex",
											alignItems: "center",
											gap: "5px",
										}}
									>
										<img
											src={`/assets/images/channel/timer.png`}
											alt={`공동구매`}
											className={`group-buying-alert-icon`}
											style={{
												height: "auto",
												width: "1.2em",
											}}
										/>
										<p
											style={{
												color: "#adb5bd",
											}}
										>
											예약됨{" "}
											{moment(item?.post_from).format("YYYY.MM.DD a h:mm 예정")}
										</p>
									</Button>
								)}
								<div className={`home-community-content`}>
									<div className={`community-title-div `}>
										<p
											className={`community-tag`}
											style={{ backgroundColor: `${item?.background_color}` }}
										>
											{item?.category_name}
										</p>
										<p className={`community-title`}>{item?.title}</p>
									</div>
									<div className={`community-footer-div mobile-noShow`}>
										<p>좋아요 {item?.like_num ?? 0}</p>
										<p>·</p>
										<p>댓글 {item?.comment_num ?? 0}</p>
										<p>·</p>
										<p>{moment(item?.created_at).format("YYYY.MM.DD")}</p>
									</div>
									{item?.body?.includes("<p>") ? (
										<>
											<div
												dangerouslySetInnerHTML={{
													__html: item.body
														?.replaceAll(
															`<img `,
															`<img style="display: none;" `
														)
														?.replaceAll(`<h5>`, `<p>`)
														?.replaceAll(`</h5>`, `</p>`)
														?.replaceAll(`<br>`, ``),
													// ?.replaceAll(`</p><p>`, " ")
													// ?.replaceAll(`<br>`, "")
													// ?.replaceAll(`<a`, `<p`),
												}}
												className={`community-body-div community-body-content-line5`}
											/>
											{item?.body?.split(`</p><p>`)?.length - 1 >= 5 && (
												<p className={`body-detail`}>...자세히보기</p>
											)}
										</>
									) : (
										// 	<p
										// 		dangerouslySetInnerHTML={{
										// 			__html: item?.body
										// 				?.replaceAll(`</p><p>`, " ")
										// 				?.replaceAll(`<br>`, "")
										// 				?.replaceAll(`<a`, `<p`),
										// 		}}
										// 	/>
										// 	{item?.body?.split(`</p><p>`)?.length - 1 >= 5 && (
										// 		<p className={`body-detail`}>...자세히보기</p>
										// 	)}
										// </div>
										<div className={`community-body-div`}>
											<p>{item?.body?.replace("\n", "")}</p>
											{item?.body?.split("\n")?.length - 1 >= 5 && (
												<p className={`body-detail`}>...자세히보기</p>
											)}
										</div>
									)}
								</div>
								{!!(!!item?.communityImageList?.length && user?.id) && (
									<>
										<CommunityImage imageList={item?.communityImageList} />
									</>
								)}
								<div className={`community-footer-div mobile-show`}>
									<p>좋아요 {item?.like_num ?? 0}</p>
									<p>·</p>
									<p>댓글 {item?.comment_num ?? 0}</p>
									<p>·</p>
									<p>{moment(item?.created_at).format("YYYY.MM.DD")}</p>
								</div>
								{item?.influencer_id === user?.id && (
									<Row className={`community-edit-button-group`}>
										<Button onClick={(e) => editCommunity(e, item)}>
											수정
										</Button>
										<Button onClick={(e) => deleteCommunity(e, item)}>
											삭제
										</Button>
									</Row>
								)}
							</div>
						</div>
					))}
				</>
			) : (
				<Row
					align={"middle"}
					style={{ width: "100%", flexDirection: "column", padding: "3em 0" }}
				>
					<img
						src={`/assets/images/warning.png`}
						alt={`warning-icon`}
						style={{
							width: "3.5em",
							height: "auto",
						}}
					/>
					<span
						style={{
							marginTop: "1em",
							color: "#adb5bd",
							fontSize: "1.2em",
							fontWeight: 500,
						}}
					>
						일치하는 내용이 없습니다.
					</span>
				</Row>
			)}
			{/*/!* 건별 콘텐츠 보기 *!/*/}
			{/*{modalShow && (*/}
			{/*    <CommunityModal*/}
			{/*        modalShow={modalShow}*/}
			{/*        setModalShow={setModalShow}*/}
			{/*        detail={selectCommunity}*/}
			{/*        whereShow={'edit'}*/}
			{/*        // getCommunityList={getCommunityList}*/}
			{/*    />*/}
			{/*)}*/}
			<div ref={obsRef} />
			<Pagination
				className="report-pagination-wrap"
				style={{
					margin: "auto",
				}}
				showSizeChanger={false}
				current={currentPageNumber}
				pageSize={pageSize}
				total={totalCount}
				onChange={handleChangePagination}
			/>
		</>
	);
};
export default EditCommunityListComponent;
